// extracted by mini-css-extract-plugin
export default {"container":"_2wnpgfELOtoylKPVMYY6mv","contactImage":"_14wrXvOjiWSD8Zk3hcf6GU","contactPerson":"_1qGV5sG62Kb78O2fYYr80g"};